import React from "react";
import EditGroupMenuComp from "../../components/GroupMenu/EditGroupMenu";
const EditGroupMenu = () => {
  return (
    <div>
      <EditGroupMenuComp />
    </div>
  );
};

export default EditGroupMenu;
